import { useContext, useEffect, useState } from "react";
import { Badge } from "@mui/material";
import { theme } from "../../../../theme";
import { Context } from "../../Provider";
import { fetchAdminDetailsInFirebase } from "../../service";

const EditAndChatButtons = () => {
    const { state, openEditView, openChatView } = useContext(Context);
    const ftm = state?.ftm;

    const [unreadMessageCount, setUnreadMessageCount] = useState(0);

    useEffect(() => {
        if (!ftm?.ftm_firebase_document_id) return;

        const getAdminDetailsInFirebase = async () => {
            try {
                const count = await fetchAdminDetailsInFirebase(ftm.ftm_firebase_document_id);
                setUnreadMessageCount(count || 0);
            } catch (err) {
                console.error("Failed to fetch admin details:", err);
            }
        };

        getAdminDetailsInFirebase();
    }, [ftm?.ftm_firebase_document_id]);

    const handleOpenChatView = () => {
        if (ftm?.ftm_firebase_document_id) {
            openChatView(ftm.ftm_firebase_document_id);
        }
    };

    if (!ftm) return null;

    return (
        <div className="nav-wrapper position-relative end-0">
            <ul className="nav nav-pills nav-fill p-1 bg-gray-300">
                <li className="nav-item" role="presentation">
                    <div className="nav-link mb-0 px-0 py-1 cursor-pointer" onClick={openEditView}>
                        <i className="material-icons text-lg position-relative">edit</i>
                        <span className="ms-2 font-weight-bold">Edit</span>
                    </div>
                </li>
                <li className="nav-item" role="presentation">
                    <Badge
                        badgeContent={unreadMessageCount}
                        color={theme.sidebar_notification_count_color}
                    >
                        <div className="nav-link mb-0 px-0 py-1 cursor-pointer" onClick={handleOpenChatView}>
                            <i className="material-icons text-lg position-relative">settings</i>
                            <span className="ms-2 font-weight-bold">Chat</span>
                        </div>
                    </Badge>
                </li>
            </ul>
        </div>
    );
};

export default EditAndChatButtons;